import { call, put, select } from "redux-saga/effects";

// Api
import { fetchShopSpins, fetchBrandShopProducts } from "../../../api";

// Actions
import { profileActions } from "../../../actions/profile";

export function* fetchStartShopProducts({ payload: { slug } }) {
  // Check if this is a brand profile
  const { profileInfo } = yield select((state) => state.profileReducer);
  const isBrandProfile = profileInfo?.business_role === "brand";

  // Use the appropriate API based on profile type
  const apiFunction = isBrandProfile ? fetchBrandShopProducts : fetchShopSpins;
  const res = yield call(apiFunction, slug, 0);

  if (res.response) {
    yield put(profileActions.fetchStartShopProductsSucceed(res.response));
  }
}

export function* fetchShopProducts({ payload: { slug, page } }) {
  // Check if this is a brand profile
  const { profileInfo } = yield select((state) => state.profileReducer);
  const isBrandProfile = profileInfo?.business_role === "brand";

  // Use the appropriate API based on profile type
  const apiFunction = isBrandProfile ? fetchBrandShopProducts : fetchShopSpins;
  const res = yield call(apiFunction, slug, page);

  if (res.response) {
    yield put(profileActions.fetchShopProductsSucceeded(res.response.products));
  }
}
